import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios"
import { Dispatch } from "react"

export const DOCUMENT_UPLOAD_START = "DOCUMENT_UPLOAD_START"
export const DOCUMENT_UPLOAD_WARNING = "DOCUMENT_UPLOAD_WARNING"
export const DOCUMENT_UPLOAD_SUCCESS = "DOCUMENT_UPLOAD_SUCCESS"
export const DOCUMENT_UPLOAD_ERROR = "DOCUMENT_UPLOAD_ERROR"
export const DOCUMENT_UPLOAD_RESET = "DOCUMENT_UPLOAD_RESET"

export const SINGLE_DOCUMENT_UPLOAD_SUCCESS = "SINGLE_DOCUMENT_UPLOAD_SUCCESS"
export const SINGLE_DOCUMENT_UPLOAD_START = "SINGLE_DOCUMENT_UPLOAD_START"
export const SINGLE_DOCUMENT_UPLOAD_WARNING = "SINGLE_DOCUMENT_UPLOAD_WARNING"
export const SINGLE_DOCUMENT_UPLOAD_ERROR = "SINGLE_DOCUMENT_UPLOAD_ERROR"

const myUploadProgress = (currentFile, dispatch) => (progressEvent) => {
	if (progressEvent.lengthComputable) {
		currentFile.uploadPercentage = parseInt(
			Math.round((progressEvent.loaded * 100) / progressEvent.total)
		)
		dispatch({
			type: SINGLE_DOCUMENT_UPLOAD_START,
			payload: {
				fileName: currentFile.name,
				progress: currentFile.uploadPercentage,
			},
		})
	}
}

export interface IUploadResponse {
	errors: number
	fileName: string
	outcome: string
}

export type UploadActionType =
	| { type: "DOCUMENT_UPLOAD_START" }
	| { type: "SINGLE_DOCUMENT_UPLOAD_START"; payload: any }
	| { type: "SINGLE_DOCUMENT_UPLOAD_SUCCESS" }
	| { type: "SINGLE_DOCUMENT_UPLOAD_WARNING" }
	| { type: "DOCUMENT_UPLOAD_SUCCESS" }
	| { type: "DOCUMENT_UPLOAD_WARNING" }
	| { type: "DOCUMENT_UPLOAD_ERROR" }

export function uploadDocuments({
	fileId,
	bankId,
	campaignId,
	corporateSenderId,
	bankAccount,
	files,
	dispatchReact,
}: {
	fileId: string | undefined
	bankId: string
	campaignId: string
	corporateSenderId: string
	bankAccount: string
	files: File[]
	dispatchReact: Dispatch<UploadActionType>
}) {
	dispatchReact({
		type: DOCUMENT_UPLOAD_START,
	})

	let errorsUpload = 0
	let warningUpload = 0
	const promiseArray: Promise<void | AxiosResponse<unknown, unknown>>[] =
		files.map((file: File) => {
			dispatchReact({
				type: SINGLE_DOCUMENT_UPLOAD_START,
				payload: { fileName: file.name },
			})

			const url = fileId
				? `${process.env.REACT_APP_FILE_SERVICE_API_URL}/fileservice/apifile/${bankId}/v2/reupload/${fileId}`
				: `${process.env.REACT_APP_FILE_SERVICE_API_URL}/fileservice/apifile/${bankId}/v2/upload`

			const config: AxiosRequestConfig = {
				headers: {
					"Content-Type": "multipart/form-data",
				},
				withCredentials: true,
			}

			const formData = new FormData()
			formData.append("file", file)
			formData.append("campaignId", campaignId)
			formData.append("corporateSenderId", corporateSenderId)
			formData.append("senderAccount", bankAccount)

			config.onUploadProgress = myUploadProgress(file, dispatchReact)
			config.onDownloadProgress = myUploadProgress(file, dispatchReact)

			return axios
				.post(url, formData, config)
				.then((result, error) => {
					if (
						result.status === 200 ||
						result.status === 201 ||
						result.status === 202
					) {
						if (result?.data?.errors > 0) warningUpload++
						dispatchReact({
							type:
								result?.data?.outcome === "EXCEPTION"
									? SINGLE_DOCUMENT_UPLOAD_ERROR
									: SINGLE_DOCUMENT_UPLOAD_SUCCESS,
							payload: {
								fileName: file.name,
								fileProgress: file.uploadPercentage,
								result: result?.data,
							},
						})
					} else {
						errorsUpload++
						dispatchReact({
							type: SINGLE_DOCUMENT_UPLOAD_ERROR,
							payload: {
								status: result.status,
								fileName: file.name,
								result: {
									outcome: "INTERNAL_SERVER_ERROR",
								},
							},
						})
					}
				})
				.catch((response: AxiosError) => {
					errorsUpload++
					const axiosError = response as AxiosError<string>
					let statusMessage
					statusMessage =
						axiosError.status === 400
							? axiosError.response?.data
							: "INTERNAL_SERVER_ERROR"
					statusMessage = statusMessage.split("+")
					dispatchReact({
						type: SINGLE_DOCUMENT_UPLOAD_ERROR,
						payload: {
							fileName: file.name,
							message: statusMessage,
							status: axiosError.status ?? 500,
							result: {
								outcome: statusMessage?.[0],
								realMimeType: statusMessage?.[1],
							},
						},
					})
				})
		})
	return axios
		.all(promiseArray)
		.then(() => {
			if (errorsUpload < 1 && warningUpload < 1) {
				dispatchReact({
					type: DOCUMENT_UPLOAD_SUCCESS,
				})
			} else if (warningUpload > 0) {
				// mi servono i documenti totali e gli errori per visualizzare un warning (alcui doc caricati) o un errore(nessun doc caricato)
				dispatchReact({
					type: DOCUMENT_UPLOAD_WARNING,
					error: {
						numberFiles: files.length,
						errorFiles: errorsUpload,
						warningFiles: warningUpload,
					},
				})
			}
		})
		.catch((response: AxiosError) => {
			dispatchReact({
				type: DOCUMENT_UPLOAD_ERROR,
				error: {
					numberFiles: files.length,
					errorFiles: errorsUpload,
					warningFiles: warningUpload,
				},
			})
		})
	//};
}
